"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var withContentHOC = function (Component) {
    return function (props) { return (
    // TODO Add breakpoint aware margin selector https://jira.oci.oraclecorp.com/browse/DUPLO-1030
    React.createElement("div", { className: "oui-margin-left oui-margin-right" },
        React.createElement(Component, __assign({}, props)))); };
};
exports.default = withContentHOC;
//# sourceMappingURL=withContentHOC.js.map